/**
 * @file
 *
 * This file describes the 'Reducer' mapping, is also a good point to define 'Epic' functions.
 * Note that an Action always run first through the reducer before the Epic even receive it.
 * @author JPablo
 */
import {AnyAction} from "redux";
import "rxjs/operators/delay";
import {
    ABRIR_MENU,
    CERRAR_MENU,
    CONSULTAR_MENU,
    CONSULTAR_OFICINAS,
    ERROR_AUTORIZACION,
    ERROR_CONSULTANDO_MENU,
    errorAutorizacion,
    errorConsultandoMenu,
    errorConsultandoOficinas,
    MENU_CONSULTADO,
    menuConsultado,
    OFICINAS_CONSULTADAS,
    oficinasConsultadas
} from "./inicioActions";
import {authenticatedAjax, REQUEST} from "../../config/ajax-wrapper";
import * as moment from "moment";

/*
* Epics
* https://redux-observable.js.org/docs/basics/Epics.html
*/

export const consultarMenuEpic = action$ =>
    action$.ofType(CONSULTAR_MENU)
        .mergeMap((action) => {
            return authenticatedAjax
                .get(
                    "index"
                )
                .map((response) => {
                    const menuJson = JSON.parse(response.response);
                    return menuConsultado(obtenerMenu(menuJson.menu), menuJson.dni,
                        menuJson.lastAccess, menuJson.logoutURL, menuJson.fullName, menuJson.isSuper);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }

                    return [errorConsultandoMenu()];
                });
        });

export const consultarOficinasEpic = action$ =>
    action$.ofType(CONSULTAR_OFICINAS)
        .mergeMap((action) => {
            return authenticatedAjax
                .get(
                    "oficinas"
                )
                .map((response) => {
                    const oficinas = JSON.parse(response.response);
                    return oficinasConsultadas(oficinas);
                })
                .catch(_ => {
                    return [errorConsultandoOficinas()];
                });
        });

/*
* Reducer
* https://redux.js.org/docs/basics/Reducers.html
 */
export const inicioReducer = (state = {estado: REQUEST.NONE, oficinas: [], menuOpened: false}, action: AnyAction) => {
    switch (action.type) {
        case CONSULTAR_MENU:
            return {...state, estado: REQUEST.PENDING};
        case MENU_CONSULTADO:
            return {
                ...state,
                menu: action.menu,
                estado: REQUEST.SUCCESS,
                nombreLogin: action.fullName,
                dniLogin: action.dniLogin,
                lastAccess: moment(action.lastAccess, 'x').format('DD/MM/YYYY - hh:mm:ss A'),
                logoutURL: action.logoutURL,
                isSuper: action.isSuper
            };
        case ERROR_CONSULTANDO_MENU:
            return {...state, estado: REQUEST.ERROR};
        case ERROR_AUTORIZACION:
            return {...state, estado: REQUEST.FORBIDDEN, seusForm: action.respuesta, codigo: action.codigo};
        case CONSULTAR_OFICINAS:
            return {...state, oficinas: []};
        case OFICINAS_CONSULTADAS:
            return {...state, oficinas: action.oficinas};
        case ABRIR_MENU:
            return {...state, menuOpened: true};
        case CERRAR_MENU:
            return {...state, menuOpened: false};
        default:
            return state;
    }
};

const obtenerMenu = (menuJson: Array<string>): Array<any> => {
    return menuJson.map(menu => JSON.parse(menu)).sort((a, b) => a.menuItems[0].order - b.menuItems[0].order);
};


// WEBPACK FOOTER //
// ./src/co/sura/inicio/modulos/inicioReducers.ts